function ajax_call(method, url, data, callback, $target_container, show_loader, async, extra_opts, auto_data) {

    if(typeof(data) === 'undefined') {
        data = {};
    }

    if(typeof($target_container) === 'undefined') {
        $target_container = $('body');
    }

    if(typeof(show_loader) === 'undefined') {
        show_loader = false;
    }

    if(typeof(async) === 'undefined') {
        async = true;
    }

    if(typeof(extra_opts) === 'undefined') {
        extra_opts = false;
    }

    if(typeof(auto_data) === 'undefined') {
        auto_data = true;
    }

    var $loader = $target_container.find('.loader').first();

    //Let the server know this is an ajax call
    if(auto_data) {
        data.ajax = true;

        //Add CSRF token to call
        data.csrf_token = $("input[name=csrf_token]").val();

        //If token not found, use variable value
        if(typeof(data.csrf_token) === 'undefined' || data.csrf_token === null) {
            data.csrf_token = token;
        }
    }

    //Set ajax options
    var opts = {
        method: method,
        url: url,
        data: data,
        async: async,
        success: function(resp) {

            //Hide loading icon if enabled
            if(show_loader) {
                $loader.fadeOut(fade_speed);
            }

            //Run the callback function
            if(typeof(callback) !== 'undefined') {
                callback(resp);
            }

        },
        error: function(xhr, status, error) {

            //Hide loading icon if enabled
            if(show_loader) {
                $loader.fadeOut(fade_speed);
            }

            //Unauthorised access - show error
            if(xhr.status === 401) {

                //Get response and parse it
                var resp = $.parseJSON(xhr.responseText);

                //Show alert box
                alert(resp.message);
                window.location.reload();
                return;
            }

            //Show error message
            if(xhr.responseText) {
                alert(xhr.responseText);
            }

        }
    };

    //Show loading icon if enabled
    if(show_loader) {
        $loader.fadeIn(fade_speed);
    }

    if(extra_opts) {
        $.extend(opts, extra_opts);
    }

    //Make the call
    return $.ajax(opts);

}

function get_element_pos($element) {

    if($element.length > 0) {
        return $element.offset().top;
    }

}

function scroll_to_pos(pos, speed) {

    //Default to 0 if not set
    if(typeof(pos) === 'undefined') {
        pos = 0;
    }

    //Default to 1000 if not set
    if(typeof(speed) === 'undefined') {
        speed = 1000;
    }

    //If not already at the desired position...
    if($(document).scrollTop() !== pos) {

        //Scroll to position
        $("html, body").animate({
            scrollTop: pos
        }, speed);

    }
}

function show_alert(success, msg) {

    var $alert = $('.alert.form-alert');
    var html = '';

    if(success) {
        $alert.removeClass('alert-danger').addClass('alert-success');
    } else {
        $alert.removeClass('alert-success').addClass('alert-danger');
    }

    //Make message into array if not already
    if(msg.constructor !== Array) {
        msg = [msg];
    }

    //Loop over messages
    for(var i = 0; i < msg.length; i++) {

        //Build html from messages
        html += '<p>' + msg[i] + '</p>';

    }

    //Add final html to alert
    $alert.html(html);

    //Remove animation classes
    $alert.removeClass('bounce');

    //Re-add them (have to delay or it won't replay)
    setTimeout(function() {
        $alert.addClass('bounce');
    }, 50);

}
